module.exports = __webpack_public_path__ + "img/QUICK-PACK.74daa9de.png";